const indicatorWrapper = {
  display: "flex",
  gap: "8px",
  alignItems: "center"
};
const dotWrapper = {
  width: "10px",
  height: "10px",
  position: "relative"
};
const size = "10px";
const dotIndicator = (color) => ({
  width: size,
  height: size,
  top: "1.67px",
  left: "1.67px",
  borderRadius: "100px",
  position: "absolute",
  background: color
});
export {
  dotIndicator,
  dotWrapper,
  indicatorWrapper
};
